<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {changeStep, Steps, isSavingCurrentStep} from "@/composables/ai-onboarding/useSteps";

const emit = defineEmits(['changeStep']);

defineProps({
  canBypassAiOnboarding: {
    type: Boolean,
    required: true,
  },
});

const handleContinue = () => {
  changeStep(Steps.LOCATIONS, emit);
}
</script>

<template>
  <div class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-text-center tw-max-w-[1120px] tw-mx-auto">
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-18 tw-gap-y-20 tw-mb-28">
      <div class="tw-flex tw-flex-col">
        <h1 class="tw-text-4xl tw-font-bold tw-text-grey-dark">
          Right, time to build your website’s SEO strategy
        </h1>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-20 tw-items-center tw-w-[608px]">
        <div class="tw-flex tw-flex-col tw-gap-6 tw-items-center">
          <svg-vue
            class="tw-w-[260px]"
            icon="illustrations/ai-onboarding-image-1"
          />

          <p class="tw-text-base tw-text-slate-200">
            Before we dive in, our built-in SEO expert needs to understand your business and your ideal customers. These steps ensure the SEO strategy we build for you is laser-focused on driving the right traffic and leads for your business. I’m now going to ask you a few questions about your business, customers, and goals so I can create a focused SEO plan that brings you the right traffic.
          </p>

          <p class="tw-text-base tw-text-slate-200">
            This should take around 10–15 minutes, and I’ll guide you every step of the way. Ready to begin?
          </p>
        </div>

        <div
          class="tw-flex tw-w-full tw-items-center"
          :class="[
            canBypassAiOnboarding ? 'tw-justify-between' : 'tw-justify-end'
          ]"
        >
          <a
            v-if="canBypassAiOnboarding"
            class="tw-text-base tw-font-bold tw-text-blue tw-underline"
            href="/onboarding"
          >
            I’ll build my strategy myself
          </a>

          <DefaultButton
            class="tw-w-48 tw-self-end"
            :loading="isSavingCurrentStep"
            @click="handleContinue"
          >
            Let's Start!
          </DefaultButton>
        </div>
      </div>
    </div>
  </div>
</template>
